import { NavigationGuardNext, Route } from 'vue-router';
import store from '@/store';
import { NAME_ROUTES_BOOK } from '@/router/routes/Book';

import { LIST_PERMISSION } from '@/constant/ListPermission';
import { LIST_PLAN_ID } from '@/constant/PlansIDs';
import Permission from './index';

export function permissionDashboard(to: Route, from: Route, next: NavigationGuardNext<Vue>) {
  const PermissionClass = new Permission();

  const isDashboard = PermissionClass.can(LIST_PERMISSION.DASHBOARD);
  const isPlanFree = store.getters.profile?.plan?.planID === LIST_PLAN_ID.FREE;

  const hasAccess = isDashboard || isPlanFree;

  if (hasAccess) {
    next(); 
    return;
  }

  next({ name: NAME_ROUTES_BOOK.LIST });
}

export function checkInstitution(to: Route, from: Route, next: NavigationGuardNext) {
  const { profile } = store.getters;
  const hasInstitution = !!profile?.institution?.id;

  if (hasInstitution && from.name === null) {
    next({ name: NAME_ROUTES_BOOK.LIST });
    return;
  }

  next();
}
